import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

type Props = {
  /**
   * Libellé IGN résolu, affiché systématiquement (#919, critère n°1 de #864) :
   * la phrase montre ce qui a été trouvé, sans jamais affirmer que la
   * position est bonne.
   */
  label: string;
};

// État `reliable` : précision de géocodage jugée fiable (#797).
export function AddressRecognized({label}: Props) {
  return (
    <div style={{marginBottom: "8px"}}>
      <div style={{fontSize: "13px", color: "var(--mt-color-action)"}}>
        <FontAwesomeIcon icon="check-circle" className="me-1" />
        Adresse reconnue
      </div>
      <div style={{fontSize: "12px", color: "#6c757d", paddingLeft: "20px"}}>
        <FontAwesomeIcon icon="map-marker-alt" className="me-1" />
        {label}
      </div>
    </div>
  );
}
